module.exports = __webpack_public_path__ + "img/axe_4_strategie.3f7de9e3.svg";